import React from 'react';
import { readableErrorMessage } from '../utils/appErrors';

type ModalActionErrorProps = {
  message: string | null;
  title?: string;
  hint?: string;
  className?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
};

export function ModalActionError({
  message,
  title = 'That action could not be completed',
  hint,
  className,
  actionLabel,
  onAction,
  actionDisabled = false,
}: ModalActionErrorProps) {
  const alertRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!message || typeof window === 'undefined') return undefined;
    alertRef.current?.focus({ preventScroll: true });
    alertRef.current?.scrollIntoView?.({ block: 'nearest' });
    return undefined;
  }, [message]);

  if (!message) return null;

  const classes = className
    ? `modal-action-error-shell ${className}`
    : 'modal-action-error-shell';

  return (
    <div className={classes}>
      <div
        ref={alertRef}
        className="modal-action-error"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        tabIndex={-1}
      >
        <span className="modal-action-error__icon" aria-hidden="true">!</span>
        <span className="modal-action-error__copy">
          <strong>{title}</strong>
          <span>{readableErrorMessage(message)}</span>
          {hint ? <small>{hint}</small> : null}
          {actionLabel && onAction ? (
            <button
              type="button"
              className="btn modal-action-error__action"
              onClick={onAction}
              disabled={actionDisabled}
            >
              {actionLabel}
            </button>
          ) : null}
        </span>
      </div>
    </div>
  );
}
